import { Grid } from "antd";
import { FC, HTMLAttributes } from "react";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import ClassSelectionWeb from "./layouts/ClassSelection.web";
import ClassSelectionMob from "./layouts/ClassSelection.mob";

const ClassSelectionComponent = withConditionalComponent(ClassSelectionWeb, ClassSelectionMob);

const ClassSelect: FC<{ wrapperProps?: HTMLAttributes<HTMLDivElement> }> = ({ wrapperProps }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return <ClassSelectionComponent trigger={isLargeScreen} props={{ wrapperProps }} />;
};

export default ClassSelect;
